module.exports = __webpack_public_path__ + "img/wallet.12ef276c.svg";